export const youtubeDataTypes = {
    youtube_data_upload: {
        data_type: 'youtube_data_upload',
        data_type_description: 'Youtube Watch History',
        logo: 'https://i.imgur.com/ZwR1oYS.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: false,
        generic: {
        },
        file_source: 'localStorage',
        instructions_type: 'component'
    },
}